module.exports = __webpack_public_path__ + "img/logo.eaeb6e9a.png";